<template>
  <div class="laboral-references-module" v-if="project != null">
    <div class="block no-have-references" v-if="not_have_references != null">
      <div :class="typeMessage" role="alert" v-if="message != ''">
        {{message}}
      </div>

      <div class="info-laboral row-gw">
        <h2>En caso de que el candidato no cuente con referencias por favor diligencie este formulario. Debe quedar claro el motivo por el cual el candidato no posee referencias</h2>
      </div>

      <div class="row">
        <label class="col-sm-3 col-form-label">El aspirante cuenta con referencias laborales ?<label class="text-danger">*</label></label>
        <div class="col-md-9">
          <label class="switch">
            <input type="checkbox" class="form-control" v-model="not_have_references">
            <span class="slider round"></span>
          </label>
        </div>    
      </div>

      <div class="row reason" v-if="!not_have_references">
        <label class="col-md-3 control-label" for="">Por qué razón no cuenta con referencias laborales ?</label>
        <div class="col-md-6">
          <textarea class="form-control" id="exampleFormControlTextarea1" v-model="project.reason_not_have_laboral_references" v-if="project.type_work_experience !== 1" rows="3"></textarea>
          <textarea class="form-control" id="exampleFormControlTextarea1" v-if="project.type_work_experience === 1" disabled rows="3"> El candidato expresa NO contar con experiencia laboral </textarea>
          <span class="help-block">Diligencie este campo solo si el candidato no cuenta con referencias laborales</span>
        </div>      
      </div>

      <div class="row">
        <div class="col-md-3">
          <button class="btn btn-primary btn-lg btn-block" @click.prevent="saveReason">Guardar</button>
        </div>
      </div>
    </div>
    <template v-if="not_have_references">
      <Form />      
    </template>
    <Table />      
  </div>
</template>

<script>
  import axios from 'axios';
  import Form from './Form.vue'
  import Table from './Table.vue'
  import { mapMutations } from 'vuex'
  export default {
    props: {
      project: null
    },
    data() {
      return {
        not_have_references: null,
        typeMessage: '',
        message: '',
      }
    },
    methods: {
      ...mapMutations(['changeProject']),
      setHeaders () {
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        axios.defaults.headers["x-csrf-token"] = token
        axios.defaults.headers.common["Accept"] = "application/json"
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
      },
      async saveReason () {
        this.setHeaders()
        if (this.not_have_references) this.project.reason_not_have_laboral_references = null
        let request = await axios.put(`/update_information_project`, { project: { id: this.project.id, not_have_laboral_references: this.not_have_references, reason_not_have_laboral_references: this.project.reason_not_have_laboral_references} })
        if (request.status == 200) {
          this.showMessage('Información guardada.', 'alert-success')
        }
      },
      showMessage(message, typeMessage){
        this.message = message
        this.typeMessage = `alert ${typeMessage}`
        setTimeout(() => this.message = '', 3000)
      }
    },
    components: {
      Form,
      Table
    },
    mounted () {
      if (this.project != null) {
        this.changeProject(this.project)
        if (this.project.not_have_laboral_references) {
          this.not_have_references = true
        } else {
          this.not_have_references = false
        }
        if (this.project.laboral_references.length > 0) this.not_have_references = true
        if (this.project.type_work_experience === 1) this.not_have_references = false

      }
      console.log(this.project)
    },
  }
</script>

<style scoped>

</style>